export { default } from './ShopComponent.tsx';
